// extracted by mini-css-extract-plugin
module.exports = {"eventInfoIntro":"EventIntro_eventInfoIntro__3qnRs","image":"EventIntro_image__1k5IM","title":"EventIntro_title__1FH7T","addEventBtn":"EventIntro_addEventBtn__WzGJc"};